import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import koCommon from '../locales/ko/common.json';
import koHome from '../locales/ko/home.json';
import koPages from '../locales/ko/pages.json';
import koBrandStory from '../locales/ko/brandStory.json';
import koSvc from '../locales/ko/svc.json';
import koUcParents from '../locales/ko/ucParents.json';
import koUcDaycare from '../locales/ko/ucDaycare.json';
import koUcEvents from '../locales/ko/ucEvents.json';
import koUcSeniors from '../locales/ko/ucSeniors.json';
import koLegal from '../locales/ko/legal.json';
import enCommon from '../locales/en/common.json';
import enHome from '../locales/en/home.json';
import enPages from '../locales/en/pages.json';
import enBrandStory from '../locales/en/brandStory.json';
import enSvc from '../locales/en/svc.json';
import enUcParents from '../locales/en/ucParents.json';
import enUcDaycare from '../locales/en/ucDaycare.json';
import enUcEvents from '../locales/en/ucEvents.json';
import enUcSeniors from '../locales/en/ucSeniors.json';
import enLegal from '../locales/en/legal.json';
import jaCommon from '../locales/ja/common.json';
import jaHome from '../locales/ja/home.json';
import jaPages from '../locales/ja/pages.json';
import jaBrandStory from '../locales/ja/brandStory.json';
import jaSvc from '../locales/ja/svc.json';
import jaUcParents from '../locales/ja/ucParents.json';
import jaUcDaycare from '../locales/ja/ucDaycare.json';
import jaUcEvents from '../locales/ja/ucEvents.json';
import jaUcSeniors from '../locales/ja/ucSeniors.json';
import jaLegal from '../locales/ja/legal.json';

void i18n.use(initReactI18next).init({
  resources: {
    ko: {
      common: koCommon,
      home: koHome,
      pages: koPages,
      brandStory: koBrandStory,
      svc: koSvc,
      ucParents: koUcParents,
      ucDaycare: koUcDaycare,
      ucEvents: koUcEvents,
      ucSeniors: koUcSeniors,
      legal: koLegal,
    },
    en: {
      common: enCommon,
      home: enHome,
      pages: enPages,
      brandStory: enBrandStory,
      svc: enSvc,
      ucParents: enUcParents,
      ucDaycare: enUcDaycare,
      ucEvents: enUcEvents,
      ucSeniors: enUcSeniors,
      legal: enLegal,
    },
    ja: {
      common: jaCommon,
      home: jaHome,
      pages: jaPages,
      brandStory: jaBrandStory,
      svc: jaSvc,
      ucParents: jaUcParents,
      ucDaycare: jaUcDaycare,
      ucEvents: jaUcEvents,
      ucSeniors: jaUcSeniors,
      legal: jaLegal,
    },
  },
  lng: 'ko',
  fallbackLng: 'ko',
  supportedLngs: ['ko', 'en', 'ja'],
  defaultNS: 'common',
  ns: [
    'common',
    'home',
    'pages',
    'brandStory',
    'svc',
    'ucParents',
    'ucDaycare',
    'ucEvents',
    'ucSeniors',
    'legal',
  ],
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;

export function syncDocumentLang(lng: string) {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
}

i18n.on('languageChanged', syncDocumentLang);
syncDocumentLang(i18n.language);
